<script lang="ts" setup>
import type { PropType } from 'vue'
import { computed } from 'vue'
defineProps({
  stop: {
    type: Object as PropType<{
      id: string
      name: string
      platform: string | null
      connecting_lines: Array<{
        id: string
        name: string
        colour: string
      }>
    }>,
    required: true,
  },
})
</script>
<template>
  <NuxtLink
    :to="`/stops/${stop.id}`"
    class="stop-card flex justify-between py-3 border-t border-vmcv-gray-dark"
  >
    <div class="flex flex-col">
      <div class="flex">
        <div class="font-medium">{{ stop.name }}</div>
        <div
          v-if="stop.platform"
          class="border border-vmcv-gray-darker rounded-md ml-4 px-3"
        >
          {{ stop.platform }}
        </div>
      </div>
      <div class="font-light text-xs text-vmcv-gray-darkest">{{ stop.id }}</div>
    </div>
    <div class="flex flex-wrap content-baseline">
      <StopChip
        v-for="line in stop.connecting_lines"
        :key="line.id"
        spacing
        :stop="line"
      />
    </div>
  </NuxtLink>
</template>
